"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const logic_1 = require("./logic");
/**
 * Fetch the transaction fees for a transaction
 */
const getEstimatedFees = () => __awaiter(void 0, void 0, void 0, function* () {
    // TODO: call gas station to get a more accurate tx fee in the future
    const estimateFee = Math.ceil(logic_1.FIXED_GAS_PRICE * logic_1.FIXED_DEFAULT_GAS_LIMIT);
    return new bignumber_js_1.BigNumber(estimateFee);
});
exports.default = getEstimatedFees;
//# sourceMappingURL=js-getFeesForTransaction.js.map